module.exports = __webpack_public_path__ + "bc4df2901782571cb3dfbfa9b4a16bc5.svg";